/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PointsetBody,
  PointsetChangeParameters,
  PointsetCreationParameters,
  PointsetHeader,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectPointsetClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectPointset
   * @summary Получение заголовков всех наборов точек в проекте.
   * @request GET:/geology/project/{projectId}/pointset
   * @secure
   */
  projectPointsetGetAllPointsetHeaders = (projectId: string, params: RequestParams = {}) =>
    this.http.request<PointsetHeader[], any>({
      path: `/geology/project/${projectId}/pointset`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectPointset
   * @summary Создание набора точек.
   * @request POST:/geology/project/{projectId}/pointset
   * @secure
   */
  projectPointsetCreatePointset = (
    projectId: string,
    data: PointsetCreationParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/geology/project/${projectId}/pointset`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectPointset
   * @summary Получение набора точек в проекте по идентификатору.
   * @request GET:/geology/project/{projectId}/pointset/{pointsetId}/data
   * @secure
   */
  projectPointsetGetPointsetBody = (
    projectId: string,
    pointsetId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<PointsetBody, any>({
      path: `/geology/project/${projectId}/pointset/${pointsetId}/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectPointset
   * @summary Редактирование набора точек.
   * @request PATCH:/geology/project/{projectId}/pointset/{pointsetId}
   * @secure
   */
  projectPointsetUpdatePointset = (
    projectId: string,
    pointsetId: string,
    data: PointsetChangeParameters,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/pointset/${pointsetId}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectPointset
   * @summary Удалит наборы точек из проекта, не удаляя сами наборы точек из БД.
   * @request PATCH:/geology/project/{projectId}/pointset/remove
   * @secure
   */
  projectPointsetRemovePointsetsFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/pointset/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
